import cx from 'classnames'
import type React from 'react'

import Item from './Item'
import css from './List.module.scss'

type Props = {
  urls: string[]
  selectedUrls: string[]
  onClick: (url: string) => void
}

const List: React.FC<Props> = ({ urls, selectedUrls = [], onClick }) => {
  const checkIsSelected = (url: string) => selectedUrls.includes(url)

  const containerClassName = cx(css.list)

  return (
    <div className={containerClassName}>
      {urls.map((url, i) => (
        <Item
          key={i}
          url={url}
          isSelected={checkIsSelected(url)}
          onClick={onClick}
        />
      ))}
    </div>
  )
}

export default List
